import { render } from "./PageRegister.vue?vue&type=template&id=25b0fa30&scoped=true"
import script from "./PageRegister.vue?vue&type=script&lang=js"
export * from "./PageRegister.vue?vue&type=script&lang=js"

import "./PageRegister.vue?vue&type=style&index=0&id=25b0fa30&scoped=true&lang=css"

import exportComponent from "F:\\Project Coustomer\\vue film\\film\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b0fa30"]])

export default __exports__